import { Defaults } from 'es-decorators'
import { FormView } from 'es6/views/form-view'
import { getTemplate } from 'helpers/template-helper'

/**
 * Вид формы отзыва о поиске.
 */
@Defaults({
  el: '.js-search-review-holder',
  events: {
    'change .js-review-radio': 'handleRadio',
    'click .js-search-review-submit': 'handleSubmit',
  },
  formElement: '.js-search-review-el',
  formIsOpened: false,
  additionalOptions: [
    'formElement',
    'formName',
    'searchCollection',
    'createNotification',
  ],
  notificationTemplate: '#success-notification',
  notificationHTML: null,
  isOpen: false,
  searchQuery: null,
  MIN_SEARCH_ITEMS_FOR_REVIEW: 1,
  POSITIVE_PLACEHOLDER: 'Комментировать не обязательно, но мы будем рады узнать ваше мнение.',
  NEGATIVE_PLACEHOLDER: 'Пожалуйста, расскажите, что пошло не так.',
})
export class SearchReviewView extends FormView {
  /** @inheritDoc */
  run () {
    this.notificationTemplate = getTemplate(this.notificationTemplate)
    this.notificationHTML = this.notificationTemplate({
      title: 'Спасибо за отзыв!',
      description: 'Благодаря вам мы улучшим работу поиска.',
    })
    super.run()
    this.listenTo(this.searchCollection, 'sync', this.handleSearchCollectionSync)
    this.listenTo(this.model, 'sync error', model => model.clear())
  }

  /**
   * Обработчик обновления коллекции поиска.
   * @param {app.Search} searchCollection Коллекция.
   */
  handleSearchCollectionSync ({ query, length }) {
    if (this.searchQuery !== query) {
      this.searchQuery = query
      this.toggle(length > this.MIN_SEARCH_ITEMS_FOR_REVIEW)
    }
  }

  /**
   * Обработчик изменения состояния радио кнопок.
   * @param {('0'|'1')} Значение чекбокса.
   */
  handleRadio ({ currentTarget: { value } }) {
    const text = Number(value)
      ? this.POSITIVE_PLACEHOLDER
      : this.NEGATIVE_PLACEHOLDER
    this.$('.js-review-comment').prop('placeholder', text)
    !this.formIsOpened && this.toggleForm(true)
  }

  /**
   * Переключает видимость формы.
   * @param {boolean} isOpened Признак показа формы.
   */
  toggleForm (isOpened) {
    this.formIsOpened = isOpened
    this.$('.search-review-form').toggleClass('opened', isOpened)
  }

  /**
   * Прячем форму, чистим поля, отправляем уведомление.
   */
  successSubmit () {
    this.toggle(false)
    this.toggleForm(false)
    this.clearForm()
    this.createNotification(this.notificationHTML)
  }

  /**
   * Переключает видимость текущего элемента вида.
   * @param {boolean} isOpen Признак видимости элемента.
   */
  toggle (isOpen) {
    if (isOpen !== this.isOpen) {
      this.isOpen = isOpen
      this.$el.slideToggle(300, () => this.$el.toggleClass('opened', isOpen))
    }
  }

  /**
   * Обработчик подтверждения формы.
   * @param {Event} event Событие
   */
  handleSubmit (event) {
    event.preventDefault()
    this.model.save({ ...this.getData(), request: this.searchCollection.query })
    // Не ждем ответа, сразу считаем ответ успешным.
    this.successSubmit()
  }

  /**
   * Очистка полей формы
   */
  clearForm () {
    this.$('.js-review-radio:checked').prop('checked', false)
    this.$('.review-comment').val('')
  }
}
